import type { ReactNode } from 'react';
import type { OrgCurrency } from '@/shared/utils/currencyFormatter';
import { useOrgSettings } from '@/shared/context/OrgSettingsContext';

interface CurrencyContextType {
  currency: OrgCurrency;
  loading: boolean;
  formatCurrency: (amount: number | null | undefined) => string;
  formatAmount: (amount: number | null | undefined) => string;
  currencyLabel: string;
  roundAmount: (amount: number | null | undefined) => number;
  refreshCurrency: () => Promise<void>;
}

/** @deprecated Use OrgSettingsProvider instead */
export const CurrencyProvider = ({ children }: { children: ReactNode }) => <>{children}</>;

export const useCurrency = (): CurrencyContextType => {
  const org = useOrgSettings();
  return {
    currency: org.currency,
    loading: org.loading,
    formatCurrency: org.formatCurrency,
    formatAmount: org.formatAmount,
    currencyLabel: org.currencyLabel,
    roundAmount: org.roundAmount,
    refreshCurrency: org.refreshOrgSettings,
  };
};
